var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartFileListItemCard_1;
import { Avatar, Button, Card, Tooltip, TooltipTrigger } from '@philips-internal/oswald-ui-components';
import { ButtonTheme, SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, func, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, isFunction, isMobileResolution } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import FileListItemCardAPI from './my-chart-file-list-item-card-api';
import './my-chart-file-list-item-card.css';
let MyChartFileListItemCard = MyChartFileListItemCard_1 = class MyChartFileListItemCard extends Component {
    constructor() {
        super(...arguments);
        this.abortOnClickCard = false;
        this.onClick = () => {
            if (this.abortOnClickCard) {
                this.abortOnClickCard = false;
                return;
            }
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        ...this.props
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        className: string,
        onClick: eventListener,
        onClickPacsButton: func,
        uuid: string
    }; }
    static { this.defaultProps = {
        width: 12,
    }; }
    doesShowNotViewed() {
        const { read, type } = this.props;
        return read === 'N' && type !== 'P';
    }
    renderContent() {
        const { title, savedAt, observationDescription } = this.props;
        const savedAtFormatted = ModelService.format('date', savedAt, { type: 'shortDate' });
        const fileListItemContentClass = `file-list-item-card-content ${this.doesShowNotViewed() ? 'not-viewed' : ''}`;
        return (React.createElement("div", { className: fileListItemContentClass },
            React.createElement(Tooltip, { triggers: [TooltipTrigger.HOVER], value: observationDescription, multiline: true },
                React.createElement("div", { className: "avatar-area" },
                    React.createElement(Avatar, { title: title, hideImage: true, description: isMobileResolution() ? '' : observationDescription }))),
            React.createElement("div", { className: "detail-area" },
                React.createElement("div", { className: "date" },
                    React.createElement("span", null, `${MessageService.translate('patient.date')}:`),
                    React.createElement("span", null, savedAtFormatted)))));
    }
    render() {
        const { className, width = MyChartFileListItemCard_1.defaultProps.width, dicomAccessKey } = this.props;
        const isPacsEnabled = dicomAccessKey != null;
        return (React.createElement(Card, { onClick: () => this.onClick(), uuid: generateUUID(), selectionType: SelectionType.SINGLE, className: `my-chart-file-list-item-card ${className || ''}`, width: width, selectable: true },
            this.renderContent(),
            isMobileResolution() ? this.renderDescriptionOnMobile() : null,
            this.renderPacButton(isPacsEnabled)));
    }
    renderDescriptionOnMobile() {
        const { observationDescription } = this.props;
        return (React.createElement("div", { className: "file-list-item-card-description" },
            React.createElement("p", null, observationDescription)));
    }
    renderPacButton(status) {
        const { dicomAccessKey } = this.props;
        return (React.createElement("div", { className: 'card-content' },
            React.createElement("div", { className: "my-chart-file-list-item-pacs-button" },
                React.createElement(Button, { onClick: () => this.openReport(dicomAccessKey), value: MessageService.translate('patient.view-external-exam'), size: Size.SMALL, theme: ButtonTheme.PRIMARY, enabled: status, visible: status }))));
    }
    openReport(dicomAccessKey) {
        const { onClickPacsButton } = this.props;
        this.abortOnClickCard = true;
        if (isFunction(onClickPacsButton)) {
            onClickPacsButton(dicomAccessKey);
        }
    }
};
MyChartFileListItemCard = MyChartFileListItemCard_1 = __decorate([
    AwesomeComponent({ api: FileListItemCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartFileListItemCard);
export default MyChartFileListItemCard;
//# sourceMappingURL=my-chart-file-list-item-card.js.map